export default __webpack_public_path__ + "locales/lv/WebPlugins.json?hash=5face500d5dd854b5ba4c138e14b3857";